var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.2137 13.3281L17.8356 9.23299H13.9452V6.57667C13.9452 5.45604 14.4877 4.36308 16.2301 4.36308H18V0.876675C18 0.876675 16.3945 0.599976 14.8603 0.599976C11.6548 0.599976 9.56164 2.56177 9.56164 6.11182V9.23299H6V13.3281H9.56164V23.2284C10.2767 23.3419 11.0082 23.4 11.7534 23.4C12.4986 23.4 13.2301 23.3419 13.9452 23.2284V13.3281H17.2137Z","fill":"#F3F3F3"}));
}

Facebook.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
